module.exports = __webpack_public_path__ + "fonts/OpenSans-Regular.3ed9575d.ttf";